import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FileService, SbeUploadEventTypes } from '@schoolbelle/api/file';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class FileUploadListProgressBarComponent implements OnInit {
  @Input('upload_id') upload_id:any;
  perc:number = 0;
  error:string = '';
  constructor(
    private file:FileService,
    private cdRef:ChangeDetectorRef,
  ) { }

  subscription = new Subscription();
  ngOnInit() {
    this.subscription.add(
      this.file.events.pipe(
        filter(e=>e.id === this.upload_id), 
      ).subscribe((e)=>{
        if (e.event.type === SbeUploadEventTypes.UploadError) {
          this.error = e.event.report;
        }  
        else this.error = null;
        this.perc = e.percent;
        this.cdRef.detectChanges();
      })
    );
  }
  ngOnDestroy () {
    this.subscription.unsubscribe();
  }

}
